export default __webpack_public_path__ + "static/media/magionicar-za-excel.725a352e.gif";